/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_CancelledInputs */

const en_status_cancelled = /** @type {(inputs: Status_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cancelled`)
};

const he_status_cancelled = /** @type {(inputs: Status_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בוטל`)
};

/**
* | output |
* | --- |
* | "cancelled" |
*
* @param {Status_CancelledInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const status_cancelled = /** @type {((inputs?: Status_CancelledInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_CancelledInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_cancelled(inputs)
	return he_status_cancelled(inputs)
});